import {useEffect, useState} from "react";
import useIsMobile from "./useIsMobile";

/**
 * Manages draggable button position with sessionStorage persistence
 * Validates position bounds for mobile devices to ensure visibility
 * @returns {[position, setPosition]} - Button position state and setter
 */
const useDraggableButtonPosition = () => {
  const isMobile = useIsMobile();
  const [buttonPosition, setButtonPosition] = useState(() => {
    const saved = sessionStorage.getItem("multiGameButtonPosition");
    if (!saved) return null;

    try {
      const position = JSON.parse(saved);
      const maxMobileX = 400;
      const bottomNavHeight = 90;
      const buttonSize = 70;
      const maxY = window.innerHeight - buttonSize - bottomNavHeight;

      if (isMobile && position.x > maxMobileX) {
        sessionStorage.removeItem("multiGameButtonPosition");
        return null;
      }

      if (position.y > maxY) {
        const corrected = {...position, y: maxY};
        sessionStorage.setItem("multiGameButtonPosition", JSON.stringify(corrected));
        return corrected;
      }

      return position;
    } catch (_e) {
      sessionStorage.removeItem("multiGameButtonPosition");
      return null;
    }
  });

  useEffect(() => {
    const saved = sessionStorage.getItem("multiGameButtonPosition");
    if (!saved) return;

    try {
      const position = JSON.parse(saved);
      const maxMobileX = 400;

      if (isMobile && position.x > maxMobileX) {
        sessionStorage.removeItem("multiGameButtonPosition");
        setButtonPosition(null);
      }
    } catch (_e) {
      sessionStorage.removeItem("multiGameButtonPosition");
      setButtonPosition(null);
    }
  }, [isMobile]);

  const updatePosition = newPosition => {
    setButtonPosition(newPosition);
    if (newPosition) {
      sessionStorage.setItem("multiGameButtonPosition", JSON.stringify(newPosition));
    } else {
      sessionStorage.removeItem("multiGameButtonPosition");
    }
  };

  return [buttonPosition, updatePosition];
};

export default useDraggableButtonPosition;
